/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Dont_Ask_AgainInputs */

const en_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't ask me again`)
};

const fr_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus demander`)
};

const de_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht erneut fragen`)
};

const it_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non chiedere di nuovo`)
};

const ru_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Больше не спрашивать`)
};

const es_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No volver a preguntar`)
};

const zh_cn2_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不再询问`)
};

const ja_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次回から確認しない`)
};

const hi_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिर न पूछें`)
};

const pt_pt2_explorer_assignment_email_dont_ask_again = /** @type {(inputs: Explorer_Assignment_Email_Dont_Ask_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não voltar a perguntar`)
};

/**
* | output |
* | --- |
* | "Don't ask me again" |
*
* @param {Explorer_Assignment_Email_Dont_Ask_AgainInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_dont_ask_again = /** @type {((inputs?: Explorer_Assignment_Email_Dont_Ask_AgainInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Dont_Ask_AgainInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_assignment_email_dont_ask_again(inputs)
	if (locale === "de") return de_explorer_assignment_email_dont_ask_again(inputs)
	if (locale === "it") return it_explorer_assignment_email_dont_ask_again(inputs)
	if (locale === "ru") return ru_explorer_assignment_email_dont_ask_again(inputs)
	if (locale === "es") return es_explorer_assignment_email_dont_ask_again(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_assignment_email_dont_ask_again(inputs)
	if (locale === "ja") return ja_explorer_assignment_email_dont_ask_again(inputs)
	if (locale === "hi") return hi_explorer_assignment_email_dont_ask_again(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_assignment_email_dont_ask_again(inputs)
	return en_explorer_assignment_email_dont_ask_again(inputs)
});